<template>
  <teleport to="#modals">
    <div class="modal" :class="{ 'is-active': active }">
      <div class="modal-background" @click="this.closeModal()"></div>
      <div class="modal-content has-background-white p-4 container">
        <img
          src="../assets/icons/close.svg"
          class="is-pulled-right close-button"
          @click="this.closeModal()"
        />
        <div class="is-clearfix"></div>

        <div class="columns">
          <div class="column is-12">
            <h5 class="has-text-centered font-20 font-secondary">
              Ota yhteyttä
            </h5>
            <p class="has-text-centered font-18">
              Vastaamme sinulle mahdollisimman pian!
            </p>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-12">
            <input
              class="input pm-input"
              type="text"
              placeholder="Nimi"
              v-model="form.name"
            />
            <p v-if="v$.name.$error" class="help is-danger">
              Tämä kenttä on pakollinen
            </p>
          </div>
          <div class="column is-12">
            <input
              class="input pm-input"
              type="text"
              placeholder="Sähköpostiosoitteesi*"
              v-model="form.email"
            />
            <p v-if="v$.email.$error" class="help is-danger">
              Tämä kenttä on pakollinen
            </p>
          </div>
          <div class="column is-12">
            <input
              class="input pm-input"
              type="text"
              placeholder="Puhelinnumero*"
              v-model="form.phone"
            />
            <p v-if="v$.phone.$error" class="help is-danger">
              Tämä kenttä on pakollinen
            </p>
          </div>
          <div class="column is-12">
            <input
              class="input pm-input"
              type="text"
              value="Request: Custom Plate Design"
              disabled
            />
          </div>                             
          <div class="column is-12">
            <textarea
              class="textarea has-fixed-size"
              type="text"
              placeholder="Viesti*"
              rows="6"
              v-model="form.message">
            </textarea>
            <p v-if="v$.message.$error" class="help is-danger">
              Tämä kenttä on pakollinen
            </p>
          </div>
          <div class="column is-12 has-text-centered">
            <button class="button pm-small-button my-5" @click="submitForm()">Lähetä</button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { reactive, ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "ContactFormModal",
  components: {},
  setup: (props, { expose }) => {
    const store = useStore()
    const router = useRouter()
    const active = ref(false);
    const closeModal = () => {
      active.value = false;
    };
    const showModal = () => {
      active.value = true;
    };
    expose({
      showModal,
      closeModal,
    });
    let formData = {
      name: "",
      email: "",
      phone: "",
      subject: "Request: Custom Plate Design",
      message: "",
    };

    const form = reactive(formData);

    const rules = {
      name: {
        required,
      },
      email: {
        email,
        required,
      },
      phone: {
        required,
      },
      subject: {
        required,
      },
      message: {
        required,
      },
    };

    const v$ = useVuelidate(rules, form);

    const submitForm = () => {
      v$.value.$touch()
      if (v$.value.$error) return      
      store.commit('setSpinnerState', true)
      store.dispatch('postContactForm', form).then(() => {
        store.commit('setSpinnerState', false)
        store.commit('setReseting', true)
        router.push('/')
      })
      
    }

    return {
      active,
      closeModal,
      showModal,
      form,
      v$,
      submitForm,
    };
  },
};
</script>

<style scoped lang="scss">
@use "../assets/sass/variables" as *;
.modal {
  .modal-content {
    max-width: 600px !important;
  }

  .close-button {
    cursor: pointer;
    color: #ffffff;
  }

  h2 {
    font-size: 30px;
    color: $font-color-primary;
    font-family: $font-secondary;
  }

  h3 {
    color: $font-color-primary;
    font-size: 20px;
    font-family: $font-secondary;
  }

  p {
    font-family: $font-primary;
    color: $font-color-primary;
    font-size: 20px;
    &.is-danger {
      color: #cc0029;
    }
    &.help {
      font-size: 0.75rem;
    }
  }
}
</style>
